import { createChildTablePrintContainer } from 'factories/ChildTablePrint'
import Component from 'components/Jobs/Print/Checklist'

export default createChildTablePrintContainer()(Component)
